/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsNotificationListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsNotificationListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    order_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    original_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    message?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsNotificationListItem
     */
    created_date?: Date | null;
}

export function DigitizingserviceMelcoDigitizingModelsNotificationListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsNotificationListItem {
    return DigitizingserviceMelcoDigitizingModelsNotificationListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsNotificationListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsNotificationListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order_id': !exists(json, 'order_id') ? undefined : json['order_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'original_message': !exists(json, 'original_message') ? undefined : json['original_message'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
    };
}

export function DigitizingserviceMelcoDigitizingModelsNotificationListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsNotificationListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_id': value.order_id,
        'type': value.type,
        'subject': value.subject,
        'original_message': value.original_message,
        'message': value.message,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
    };
}


